import React, { useState, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import Form from '../form/Form'
import View from '../form/View'
import Header from '../form/Header'
import InputField from '../form/InputField'
import Footer from '../form/Footer'
import { validate } from '../../utils/validators'


const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    overflowY: 'auto',
    margin: '0 36px'
  }
}))

function PersonalStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ data, setData ] = useState(props.initialData || {})
  const [ error, setError ] = useState(true) 
  
  useEffect(() => {
    const invalidFields = props.fields.filter(field => {
      return field.required && (!data[field.jsonField] || data[field.jsonField] === '' || !validate(data[field.jsonField], field.type))
    })
    setError(!!invalidFields.length)
  }, [ data, props.fields ])

  const handleFieldChange = (e, type) => {
    const { name, value } = e.target
    
    if (type === 'phone') {
      setData({ ...data, [name]: value.replace(/\D/g, '') })
    } else {
      setData({ ...data, [name]: value })
    }
  }

  const submitForm = () => {
    if (!error) {
      props.next(data)
    }
  }
 
  const handleEnterKey = () => {
    if (document.activeElement) {
      const elements = [ ...document.getElementsByTagName('input')]
      const index = elements.findIndex(element => element === document.activeElement)
      if (index < 0 || index === elements.length - 2) { // lembrar que tem um input dentro do form escondido
        //document.activeElement.blur()
        submitForm()
      } else {
        elements[index + 1].focus()
      }
    }
  }

  const getKeyboardType = type => {
    switch (type) {
      case 'phone' : return 'numeric'
      case 'email' : return 'email'
      default: return 'text'
    }
  }

  return (
    <View className={styles.root}>
      <Header 
        title={props.msg}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />
      <Form className={styles.content}>
        { props.fields.map((field) => (
          <InputField 
            type={field.type}
            label={field.name}
            name={field.jsonField}
            value={data[field.jsonField]}
            required={field.required}
            keyboardType={getKeyboardType(field.type)}
            onChange={e => handleFieldChange(e, field.type)}
            key={field.jsonField}
            customStyles={field.width ? { width: field.width } : undefined}
            onEnterKeyPress={handleEnterKey}
          />
        ))}
      </Form>
      <Footer 
        onBack={props.back}
        onNext={submitForm}
        disabled={error} 
      />
    </View>
  )
}

export default PersonalStep